// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as OnboardingScaffolding from './OnboardingScaffolding';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { RhFormInput } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: RhFormMutation
// ====================================================

export interface RhFormMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface RhFormMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: RhFormMutation_output_errors_extendedMessages[];
}

export interface RhFormMutation_output_session_rentStabInfo {
  /**
   * The last year that the user's building had rent stabilized units. If null, no
   * units were found since 2007. Note: this will never be the empty string. 
   */
  latestYear: string | null;
  /**
   * The most recent count of rent stabilized units in user's building. If null, no units were found since 2007.
   */
  latestUnitCount: number | null;
}

export interface RhFormMutation_output_session_onboardingScaffolding {
  firstName: string;
  lastName: string;
  preferredFirstName: string;
  street: string;
  city: string;
  isCityInNyc: boolean | null;
  /**
   * Whether the onboarding user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  state: string;
  borough: string;
  zipCode: string;
  aptNumber: string | null;
  email: string;
  phoneNumber: string;
  leaseType: string;
  receivesPublicAssistance: boolean | null;
  hasLandlordEmailAddress: boolean | null;
  hasLandlordMailingAddress: boolean | null;
  canReceiveRttcComms: boolean | null;
  canReceiveSajeComms: boolean | null;
}

export interface RhFormMutation_output_session {
  rentStabInfo: RhFormMutation_output_session_rentStabInfo | null;
  onboardingScaffolding: RhFormMutation_output_session_onboardingScaffolding | null;
}

export interface RhFormMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: RhFormMutation_output_errors[];
  session: RhFormMutation_output_session | null;
}

export interface RhFormMutation {
  output: RhFormMutation_output;
}

export interface RhFormMutationVariables {
  input: RhFormInput;
}

export const BlankRhFormInput: RhFormInput = {
  "firstName": "",
  "lastName": "",
  "apartmentNumber": "",
  "address": "",
  "borough": "",
  "phoneNumber": ""
};

export const RhFormMutation = {
  // The following query was taken from RhFormMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation RhFormMutation($input: RhFormInput!) {
  output: rhForm(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      rentStabInfo {
        latestYear,
        latestUnitCount
      },
      onboardingScaffolding { ...OnboardingScaffolding }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${OnboardingScaffolding.graphQL}`,
  name: "RhFormMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: RhFormMutationVariables): Promise<RhFormMutation> {
    return fetchGraphQL(RhFormMutation.graphQL, args);
  },
  blankInput: BlankRhFormInput,
};

export const fetchRhFormMutation = RhFormMutation.fetch;